import jwtDecode from "jwt-decode";

const decodeJWT = (token = "") => {
    try {
        const user = getUser();

        const userAuthToken = token || user.accessToken;

        // Decode the token without verifying its signature
        return jwtDecode(userAuthToken) as Record<string, string>;
    } catch (error) {
        // Handle any errors that might occur during decoding
        console.error("Error decoding JWT:", error);
        throw new Error("INVALID_TOKEN");
    }
};

const getLocalRefreshToken = (): string => {
    const user = getUser();
    return user?.refreshToken;
};

const getLocalAccessToken = (): string => {
    const user = getUser();
    return user?.accessToken;
};

const updateLocalAccessToken = (token: string): void => {
    const user = getUser();
    user.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
};

const getUser = (): Record<string, any> => {
    return JSON.parse(localStorage.getItem("user") || "{}");
};

const setUser = (user: Record<string, any>): void => {
    localStorage.setItem("user", JSON.stringify(user));
};

const removeUser = (): void => {
    localStorage.removeItem("user");
};

const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    updateLocalAccessToken,
    getUser,
    setUser,
    removeUser,
    decodeJWT,
};

export default TokenService;
